import React from "react";

const Footer = () => {
  return <div className="absolute-center">© Copyright 2022</div>;
};

export default Footer;
